<script>
import Drawer from "@/components/drawer";
import moment from "moment";

// Custom Components
import PageHeader from "@/components/page-header";
import RatePlan from "@/components/inventory/ratePlan.vue";
import UserService from "@/helpers/APIService/user.service";
import errorHandler from "@/helpers/errorHandler";
import Middleware from "@/helpers/middlewares";
import { authComputed } from "@/state/helpers";
import appConfig from "@/app.config";

// Rate Plan Component

export default {
  page: {
    title: "Room Rate Plan",
    meta: [
      {
        name: "description",
        content: appConfig.description,
      },
    ],
  },
  components: {
    Drawer,
    RatePlan,
    PageHeader,
  },
  data() {
    return {
      titleOfPage: "Room Rate Plan",
      text: "Add New Rate Plan",
      isLoading: true,
      isLoadingRoomDetails: true,
      table: {
        tableData: [],
        columns: [
          "selected",
          "name",
          "short_name",
          "start_date",
          "end_date",
          "actions",
        ],
        showFilter: false,
        allSelected: false,
        selectedRows: [],
        options: {
          skin: "table table-md",
          perPage: 10,
          headings: {
            name: "Name",
            short_name: "Short Name",
            start_date: "Start Date",
            end_date: "End Date",
            actions: "Actions",
          },
          perPageValues: [10, 25, 50, 100],
          sortable: ["name", "short_name", "start_date", "end_date"],
          filterByColumn: false,
          filterable: ["name", "short_name", "start_date", "end_date"],
          columnsClasses: {
            selected: "th-selected",
            actions: "float-right",
          },
          hiddenColumns: ["selected"],
        },
      },
      ratePlan: [],
      roomTypes: [],
      dates: [],
      selectedRatePlanPrice: {
        id: null,
        room_price: null,
      },
      openNewRatePlanForm: false,
      selectedRatePlan: null,
      isEdit: false,
      ratePlanNameList: [],
      ratePlanShortNameList: [],
    };
  },
  computed: {
    ...authComputed,
    ratePlanProps() {
      return {
        selectedRatePlan: this.selectedRatePlan,
        isEdit: this.isEdit,
        ratePlanNameList: [...new Set(this.ratePlanNameList)],
        ratePlanShortNameList: [...new Set(this.ratePlanShortNameList)],
      };
    },
  },
  mounted() {
    this.getRatePlans();
  },
  methods: {
    // Method is use for get all rate plan
    async getRatePlans() {
      await UserService.getRatePlanList()
        .then((rate_plans) => {
          rate_plans.map((rate_plan) => {
            this.ratePlanNameList.push(rate_plan.name.toLowerCase());
            this.ratePlanShortNameList.push(rate_plan.short_name.toLowerCase());
          });
          this.table.tableData = rate_plans;
          this.isLoading = false;
        })
        .catch((error) => {
          errorHandler(error);
        });
    },
    // Method is use for open and close add and update rate plan form
    newRatePlanForm() {
      if (this.openNewRatePlanForm == true) {
        this.selectedRatePlan = null;
        this.isEdit = false;
      }
      this.openNewRatePlanForm = !this.openNewRatePlanForm;
    },
    // Method is use for update new add and update room rate plan data
    ratePlanAddedUpdated(ratePlan) {
      if (this.isEdit == true) {
        Middleware.notification("Successfully updated !!", "success");

        this.table.tableData = this.table.tableData.map((item) => {
          if (item.id === ratePlan.id) {
            return (item = ratePlan);
          } else {
            return item;
          }
        });
      } else {
        this.table.tableData.push(ratePlan);
        Middleware.notification("Successfully added !!", "success");
      }
      this.newRatePlanForm();
    },
    // Method is use for add new rate plan and open for continue
    saveAndAddNewRatePlan(ratePlan) {
      this.table.tableData.push(ratePlan);
      Middleware.notification("Successfully added !!", "success");
    },
    // Method is use for maintained edit data
    edit(data) {
      this.selectedRatePlan = data;
      this.isEdit = true;
      this.newRatePlanForm();
    },
    // Method is use for get a single rate plan details
    getRatePlanDetails(id) {
      this.isLoadingRoomDetails = true;
      UserService.getRatePlanDetails(id)
        .then((ratePlan) => {
          this.ratePlan = ratePlan;
          this.title += " - " + ratePlan.name;
          this.roomTypes = ratePlan.room_type;
          this.dates = [];
          if (this.roomTypes.length !== 0) {
            this.roomTypes[0].date_wise_price.map((roomDate) => {
              this.dates.push({
                date: moment(roomDate.day_date),
                day: moment(roomDate.day_date).format("ddd"),
                class:
                  moment(roomDate.day_date).format("dddd") == "Sunday"
                    ? "highlight"
                    : moment(roomDate.day_date).format("dddd") == "Saturday"
                    ? "highlight"
                    : "",
              });
            });
          }
          this.isLoadingRoomDetails = false;
        })
        .catch((error) => {
          this.isLoadingRoomDetails = false;
          errorHandler(error);
        });
    },
    // Method is use for format date
    formatDate(date) {
      return moment(date).format("DD MMM");
    },
    // Method is use for select room rate plan particular value
    selectRatePlanPrice(roomRate) {
      this.selectedRatePlanPrice.id = roomRate.id;
      this.selectedRatePlanPrice.room_price = roomRate.room_price;
    },
    // Method is use for update room rate plan particular value
    deselectRatePlanPrice(
      roomRate,
      room_type_index,
      room_rate_plan_price_index
    ) {
      if (this.selectedRatePlanPrice.room_price != roomRate.price) {
        UserService.updateRatePlanPrice(
          {
            room_price: this.selectedRatePlanPrice.room_price,
          },
          this.selectedRatePlanPrice.id
        )
          .then((ratePlanPrice) => {
            this.roomTypes[room_type_index].date_wise_price[
              room_rate_plan_price_index
            ].room_price = ratePlanPrice.room_price;
            Middleware.notification("Successfully updated !!", "success");
          })
          .catch((error) => {
            errorHandler(error);
          });
      }
      this.selectedRatePlanPrice.id = null;
      this.selectedRatePlanPrice.room_price = null;
    },
  },
};
</script>

<template>
  <div>
    <PageHeader
      :title="titleOfPage"
      :isButton="true"
      :text="text"
      :action="newRatePlanForm"
    />

    <div class="row">
      <div class="col-lg-12">
        <div class="card">
          <div class="card-body">
            <div class="row">
              <div class="col-12 mt-2">
                <template v-if="isLoading">
                  <b-card
                    v-for="number in 4"
                    :key="number"
                    class="placeholder-glow"
                  >
                    <span
                      class="placeholder w-100 placeholder-lg"
                      style="height: 20px"
                    ></span>
                  </b-card>
                </template>
                <b-card
                  no-body
                  class="shadow-none"
                  v-for="data in table.tableData"
                  :key="data.id"
                >
                  <b-card-header
                    header-tag="header"
                    role="tab"
                    class="d-flex align-items-center justify-content-between"
                  >
                    <h6
                      class="float-start mt-2 w-90"
                      slot="header"
                      v-b-toggle="data.id"
                      @click="getRatePlanDetails(data.id)"
                    >
                      <span class="fs-5">
                        {{ data.name }}
                      </span>
                      <sub>
                        ( Valid From
                        <a href="javascript: void(0);">
                          {{ data.start_date }}
                        </a>
                        To
                        <a href="javascript: void(0);"> {{ data.end_date }} </a
                        >)</sub
                      >
                    </h6>
                    <div class="d-flex align-items-center float-end">
                      <a href="javascript: void(0);">
                        <i
                          class="fas fa-pencil-alt fs-5 me-1"
                          v-b-popover.hover="'Edit room rate plan'"
                          @click="edit(data)"
                        ></i>
                      </a>
                    </div>
                  </b-card-header>
                  <b-collapse
                    :id="data.id"
                    accordion="my-accordion"
                    role="tabpanel"
                    class="p-2"
                  >
                    <div
                      class="table-responsive"
                      v-dragscroll
                      style="cursor: grab"
                    >
                      <table
                        class="table table-bordered table-hover border-primary mb-0"
                      >
                        <!-- Start loader section -->
                        <thead v-if="isLoadingRoomDetails">
                          <tr>
                            <th class="placeholder-glow text-center">
                              <span
                                class="placeholder placeholder-lg th-title"
                              ></span>
                            </th>
                            <th
                              v-for="(date, index) in dates"
                              :key="index"
                              class="placeholder-glow text-center"
                              :class="date.class"
                            >
                              <span class="placeholder placeholder-lg"></span>
                            </th>
                          </tr>
                        </thead>
                        <!-- End loader section -->
                        <thead v-else>
                          <tr>
                            <th>
                              <span class="th-title">Types Of Room</span>
                            </th>
                            <th
                              v-for="(date, index) in dates"
                              :key="index"
                              :class="date.class"
                            >
                              <span class="th-date"
                                >{{ date.day }} <br />{{
                                  formatDate(date.date)
                                }}</span
                              >
                            </th>
                          </tr>
                        </thead>
                        <!-- Start Loader section -->
                        <tbody v-if="isLoadingRoomDetails">
                          <tr
                            v-for="(roomType, roomRateIndex) in roomTypes"
                            :key="roomRateIndex"
                          >
                            <th class="placeholder-glow">
                              <span class="placeholder placeholder-lg"></span>
                            </th>
                            <td
                              class="placeholder-glow text-center"
                              v-for="(
                                roomRate, key
                              ) in roomType.date_wise_price"
                              :key="key"
                              :class="dates[key].class"
                            >
                              <span class="placeholder placeholder-lg"></span>
                            </td>
                          </tr>
                        </tbody>
                        <!-- End Loader section -->
                        <tbody v-else>
                          <tr
                            v-for="(roomType, roomRateIndex) in roomTypes"
                            :key="roomRateIndex"
                          >
                            <th>{{ roomType.name }}</th>

                            <td
                              v-for="(
                                roomRate, key
                              ) in roomType.date_wise_price"
                              :key="key"
                              :class="dates[key].class"
                            >
                              <b-form-input
                                v-if="selectedRatePlanPrice.id == roomRate.id"
                                id="name-input"
                                v-model="selectedRatePlanPrice.room_price"
                                type="number"
                                autocomplete="off"
                                @blur="
                                  deselectRatePlanPrice(
                                    roomRate,
                                    roomRateIndex,
                                    key
                                  )
                                "
                              ></b-form-input>
                              <span
                                v-else
                                @click="selectRatePlanPrice(roomRate)"
                                >{{ roomRate.room_price }}</span
                              >
                            </td>
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </b-collapse>
                </b-card>
                <div
                  v-if="!isLoading && table.tableData.length == 0"
                  class="w-100"
                >
                  <span class="d-flex justify-content-center">
                    <img
                      src="@/assets/images/empty.svg"
                      class="img-fluid"
                      alt=""
                    />
                  </span>
                  <span class="text-center">
                    <p>
                      <span class="text-secondary">No Data Found</span>
                    </p>
                  </span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <Drawer
      @close="newRatePlanForm"
      :align="'right'"
      :closeable="true"
      :maskClosable="true"
      :zIndex="1002"
      :maxWidth="1000"
    >
      <div v-if="openNewRatePlanForm">
        <RatePlan
          :currentProps="ratePlanProps"
          @submitted="ratePlanAddedUpdated"
          @cancelSubmit="newRatePlanForm"
          @saveAndAddNew="saveAndAddNewRatePlan"
        />
      </div>
    </Drawer>
  </div>
</template>
<style scoped>
.w-90 {
  width: 90%;
}

.th-title {
  width: 170px;
  display: block;
}

.th-date {
  width: 100px;
  display: block;
}

.highlight {
  background-color: #e7f8ff;
}
</style>
